import script from "./OffersCategory.vue?vue&type=script&lang=ts&setup=true"
export * from "./OffersCategory.vue?vue&type=script&lang=ts&setup=true"

import "./OffersCategory.vue?vue&type=style&index=0&id=63ade3d8&lang=scss"

const __exports__ = script;

export default __exports__